export function getQuestionTypeFromHtml(questionHtml: string, defaultType: string): string {
  try {
    let detectedType = defaultType;

    const bodyMatch = questionHtml.match(/<body[^>]*data-detected-qn-type=["']([^"']+)["']/i);
    if (bodyMatch && bodyMatch[1]) {
      detectedType = bodyMatch[1];
    } else {
      const inputMatch = questionHtml.match(/<input[^>]*id=["']KSD_DETECTED_QN_TYPE["'][^>]*value=["']([^"']+)["']/i);
      if (inputMatch && inputMatch[1]) {
        detectedType = inputMatch[1];
      }
    }


    if (detectedType === 'O_IMAGE' && typeof DOMParser !== 'undefined') {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(questionHtml, 'text/html');

        const optionsTable = doc.querySelector('#KSD_TABLE');
        if (optionsTable) {
          const optionImages = optionsTable.querySelectorAll('img');

          // No images inside the options area → treat as plain O-type
          if (!optionImages || optionImages.length === 0) {
            detectedType = 'O';
          }
        }
      } catch (innerError) {
        console.warn('Failed to analyse HTML for O_IMAGE heuristic:', innerError);
      }
    }

    return detectedType;
  } catch (error) {
    console.error('Error extracting question type from HTML:', error);
    return defaultType;
  }
}



// // utils/questionTypeUtils.js
// export const getQuestionTypeFromHtml = (html, defaultType) => {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(html, 'text/html');
//   const questionTypeMeta = doc.querySelector('meta[name="question-type"]');
//   if (questionTypeMeta) {
//     return questionTypeMeta.getAttribute('content');
//   }
//   return defaultType;
// };

